import React from 'react';
import { Box, Button, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import COLOR from '../../theme/colors';
import { useDispatch } from 'react-redux';
import { resetProductId, setProductDetail } from '../../store/productSlice';
import { clearComplaintDetail, setComplaintDetail } from '../../store/complaintSlice';

export const Header = ({ title, subtitle, buttonText = null, buttonIcon, navigateTo, activeTab, fontWeight = 700, fontSize=28, customerEmail = null }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleProductClick = () => {
    dispatch(resetProductId());
    dispatch(setProductDetail({
      title: "Register New Product",
      isEdit: false,
      productId: "",
      productName: "",
      categoryObject: {},
      subCategoryObject: {},
      serialNo: "",
      skuId: "",
      purchaseDate: "",
      warrantyDurationInDays: "",
      ...(customerEmail && { customerEmail }),
    }));

    navigate(navigateTo);
  };

  const handleComplaintClick = () => {
    dispatch(clearComplaintDetail());
    dispatch(setComplaintDetail({
      title: "Register New Complaint",
      isEdit: false,
      customerId: "",
    }));
    navigate(navigateTo);
  }
  return (
    <Box display="flex" justifyContent="space-between" className="header">
      <Heading>
        <Text
          paddingBottom={activeTab === 'products' ? '0' : '3'}
          fontSize={fontSize}
          fontWeight={fontWeight}
        >
          {title}
        </Text>
        <Text fontSize={16} fontWeight="normal">
          {subtitle}
        </Text>
      </Heading>
      {
        buttonText && (
          <Button
            size="xs"
            bg={COLOR.BLUE_BUTTON}
            color={COLOR.BLUE_BUTTON_TEXT}
            p="5"
            borderRadius="lg"
            onClick={activeTab === "products" ? handleProductClick : handleComplaintClick}
          >
            {buttonIcon} {buttonText}
          </Button>
        )}

    </Box>

  );
};
